// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"395":"75f011d4","442":"98b68403","759":"81758d0f","770":"0d4624ec"}[chunkId] + ".chunk.css";
};